const locale = {
	NO_MATCHING_RECORDS_FOUND: 'No matching records found',
};

export default locale;
